import { readFragment, ResultOf } from "gql.tada";
import { InsightsBlockGroupById } from "../../../queries/entries/InsightsBlockGroupById";
import { InsightsBlock } from "./InsightsBlock";
import { InsightsBlockFragment } from "../../../queries/fragments/InsightsBlockFragment";

export const InsightsBlockGroup = ({
  entry: { insightsBlockGroup: entry },
}: {
  entry: ResultOf<typeof InsightsBlockGroupById>;
}) => {
  return (
    <section className="container-base grid grid-cols-1 dsk:grid-cols-3 gap-x-4 gap-y-10 pb-16 dsk:pb-28">
      {entry?.blocksCollection?.items.map((block, index) => (
        <InsightsBlock
          key={index}
          block={readFragment(InsightsBlockFragment, block)}
        />
      ))}
    </section>
  );
};
